/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Catapult REST API Reference
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.7.15
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';
import MerkleProofInfoPayload from './MerkleProofInfoPayload';





/**
* The MerkleProofInfoDTO model module.
* @module model/MerkleProofInfoDTO
* @version 0.7.15
*/
export default class MerkleProofInfoDTO {
    /**
    * Constructs a new <code>MerkleProofInfoDTO</code>.
    * @alias module:model/MerkleProofInfoDTO
    * @class
    * @param payload {module:model/MerkleProofInfoPayload} 
    * @param type {String} 
    */

    constructor(payload, type) {
        

        
        

        this['payload'] = payload;this['type'] = type;

        
    }

    /**
    * Constructs a <code>MerkleProofInfoDTO</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/MerkleProofInfoDTO} obj Optional instance to populate.
    * @return {module:model/MerkleProofInfoDTO} The populated <code>MerkleProofInfoDTO</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MerkleProofInfoDTO();

            
            
            

            if (data.hasOwnProperty('payload')) {
                obj['payload'] = MerkleProofInfoPayload.constructFromObject(data['payload']);
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {module:model/MerkleProofInfoPayload} payload
    */
    payload = undefined;
    /**
    * @member {String} type
    */
    type = undefined;








}


